import { ContentfulHomepage } from '@jbhi-fi/apis/src/contentful/types';
import { HomepageProps } from '../../views/Homepage/Homepage';
import { ToProductCarouselBaseOptions } from './CarouselTransformer';
import { TakeoverBlockTransformer } from './TakeoverBlockTransformer';

export abstract class HomepageTransformer {
  static toHomepageProps = (entry: ContentfulHomepage, options: ToProductCarouselBaseOptions = {}): HomepageProps => {
    return {
      sections: entry.fields?.sections ?? [],
      takeoverBlock: entry.fields?.saleTakeover?.fields
        ? TakeoverBlockTransformer.toTakeoverBlockProps(entry.fields?.saleTakeover, options)
        : undefined,
    };
  };
}
